module.exports = __webpack_public_path__ + "img/PHONE_CALL.768c52e4.svg";